
export const UUID_COLUMN_SIZE = 330;

export const GENERIC_NAME_COLUMN_SIZE = 300;
export const GENERIC_EMAIL_COLUMN_SIZE = 300;
export const GENERIC_STATUS_COLUMN_SIZE = 220;
